module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content add-relation-content"
  }, [_c('div', {
    staticClass: "row row-relation-header"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Thêm liên kết tài khoản")]), _c('div', {
    staticClass: "row row-search"
  }, [_c('div', {
    staticClass: "box-relation-search"
  }, [_c('div', {
    staticClass: "col-md-8 box-search-left"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('label', {
    staticClass: "control-label relation-label"
  }, [_vm._v("Tìm theo tên hiển thị")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control search-relation",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": _vm.onChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "addons-button-clear",
    style: (_vm.clear_search ? 'display:block;' : 'display:none;'),
    on: {
      "click": _vm.onClear
    }
  })])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "box-btn-relation-search"
  }, [_c('button', {
    staticClass: "btn btn-relation-search",
    on: {
      "click": _vm.submitSearch
    }
  }, [_vm._v("Tìm")])])])])])])]), _c('div', {
    staticClass: "row row-list-friend"
  }, [_c('div', {
    staticClass: "col-md-12 box-list-friend"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.relations), function(o, i) {
    return _c('div', {
      staticClass: "col-md-2 col-xs-4 box-item-friend"
    }, [_c('div', {
      staticClass: "item-friend"
    }, [_c('div', {
      staticClass: "img-avt"
    }, [(o.avatar) ? _c('img', {
      attrs: {
        "src": o.avatar
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/images/faces/ic_AvatarDefault.svg")
      }
    })]), _c('div', {
      staticClass: "fullname"
    }, [_vm._v(_vm._s(o.fullname || 'default'))]), _c('div', {
      staticClass: "list-link"
    }, [_c('dropdown', {
      key: _vm.componentKey,
      attrs: {
        "objSelected": o
      },
      on: {
        "onChangeValue": _vm.changeValue
      }
    })], 1)])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b28b6c0","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Relation/RelationAdd.vue
// module id = 1550
// module chunks = 0